import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidLettermix } from '../../../../mechanics/rid-lettermix/rid-lettermix';

@Component({
  selector: 'app-lettermix-page',
  imports: [RidLettermix],
  templateUrl: './lettermix-page.html',
})
export class LettermixPage {
  protected readonly $router = inject(Router);
}
